import type { Dayjs } from 'dayjs';
import { getDayOfWeek } from 'shared/src/utils/date-utils';

export const isTodayDeliveryOperatingDay = (
  date: Dayjs,
  deliveryHolidays: string[],
): boolean => {
  const dayOfWeek = date.day();
  if (dayOfWeek === 0 || dayOfWeek === 6) return false;

  return !deliveryHolidays.includes(date.format('YYYY-MM-DD'));
};

export const findNearestTodayDeliveryOperatingDay = (
  date: Dayjs,
  deliveryHolidays: string[],
): Dayjs => {
  let nextDate = date;

  do {
    nextDate = nextDate.add(1, 'day');
  } while (!isTodayDeliveryOperatingDay(nextDate, deliveryHolidays));

  return nextDate;
};

export const getPastTodayDeliveryDeadlineText = (
  date: Dayjs,
  baseDate: Dayjs,
): string => {
  const dayText = date.isSame(baseDate.add(1, 'day'), 'day')
    ? '내일'
    : `${getDayOfWeek(date)}요일에`;

  return `주문 마감으로 ${dayText} 출발`;
};
